import { IonFooter } from '@ionic/react';
import type { ReactNode } from 'react';
import styles from './ModalFooter.module.css';

/**
 * Sticky card-style modal footer holding the primary action button(s).
 * Buttons inside should use this module's primaryButton/ghostButton classes.
 * A plain div rather than IonToolbar so the surface color extends through
 * the bottom safe-area inset (the DevicePaymentPlanModal footer treatment).
 */
const ModalFooter: React.FC<{ children: ReactNode }> = ({ children }) => (
    <IonFooter className="ion-no-border">
        <div className={styles.inner}>{children}</div>
    </IonFooter>
);

export default ModalFooter;
